import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as Group } from '@/assets/icons/group.svg';

export const GroupIcon = styled(Group, {});

export const StyledSectionTitle = styled(Box, {
  alignItems: 'stretch',
  display: 'flex',
  gap: '$2',
});
